import { RowExportTypePdf } from "types";
import { convertNumber } from "utils";
import { PdfTemplate } from "components";
import { Payload } from "../../types/CurrentStockPositionValue";

export function ExportPdfStockPositionValue({ dataList }: {
  dataList: Payload['data'],
}) {

   const columns = [
    { header: 'NO', key: 'no', width: 5 },
    { header: 'CODE', key: 'code', width: 10 },
    { header: 'PRODUCT NAME', key: 'product_name', width: 20 },
    { header: 'RETAIL VALUE', key: 'retail_value', width: 20 },
    { header: 'COGM VALUE', key: 'cogm_value', width: 20 },
    { header: 'AVG VALUE', key: 'avg_value', width: 20 },
    { header: 'GMP %', key: 'gmp', width: 20 },
    { header: 'PROFIT', key: 'profit', width: 20 },
  ];

    const dataMap: RowExportTypePdf[] = dataList.map((item, index) => ({
        no: index + 1,
        code: item.product_barcode,
        product_name: item.product_name,
        retail_value: {
            text: convertNumber(item.retail_value ?? 0).intoCurrency,
            style: { textAlign: "right" }
        },
        cogm_value: {
            text: convertNumber(item.cogm_value ?? 0).intoCurrency,
            style: { textAlign: "right" }
        },
        avg_value: {
            text: convertNumber(item.avg_price ?? 0).intoCurrency,
            style: { textAlign: "right" }
        },
        gmp: {
            text: item?.soh && item?.soh > 0 && item?.retail_value ? `${convertNumber((item?.retail_value - item?.cogm_value) / item?.retail_value * 100).intoNormalAmount}%` : "0",
            style: { textAlign: "right" }
        },
        profit: {
            text: convertNumber(Number(item?.retail_value ?? 0) - Number(item?.cogm_value ?? 0)).intoCurrency,
            style: { textAlign: "right" }
        },
    }))

    return (
        <PdfTemplate
            data={dataMap}
            module="INVENTORY"
            title="CURRENT STOCK POSITION VALUE"
            column={columns}
        />
    )
}